import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=efb8b9dc&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"
import style0 from "./Page.vue?vue&type=style&index=0&id=efb8b9dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb8b9dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efb8b9dc')) {
      api.createRecord('efb8b9dc', component.options)
    } else {
      api.reload('efb8b9dc', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=efb8b9dc&scoped=true", function () {
      api.rerender('efb8b9dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/layout/Page.vue"
export default component.exports